import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "cte-date-col" }
const _hoisted_2 = {
  key: 0,
  type: "button",
  class: ""
}
const _hoisted_3 = {
  key: 1,
  class: "cte-event-terminal"
}
const _hoisted_4 = { class: "uk-label cte-compact-label" }
const _hoisted_5 = {
  key: 0,
  colspan: "9"
}
const _hoisted_6 = {
  key: 1,
  class: "cte-condensed-col"
}
const _hoisted_7 = {
  key: 0,
  class: "uk-label tw-bg-slate-500"
}
const _hoisted_8 = {
  key: 1,
  class: "uk-label uk-label-success"
}
const _hoisted_9 = {
  key: 2,
  class: "uk-label uk-label-danger"
}
const _hoisted_10 = {
  key: 2,
  class: "cte-location-col"
}
const _hoisted_11 = {
  key: 3,
  class: "cte-condensed-col"
}
const _hoisted_12 = {
  key: 4,
  class: "cte-condensed-col"
}
const _hoisted_13 = {
  key: 5,
  class: "cte-condensed-col"
}
const _hoisted_14 = {
  key: 6,
  class: "cte-condensed-col"
}
const _hoisted_15 = {
  key: 7,
  class: "cte-condensed-col"
}
const _hoisted_16 = {
  key: 8,
  class: "cte-condensed-col"
}
const _hoisted_17 = {
  key: 9,
  class: ""
}
const _hoisted_18 = {
  key: 1,
  class: "cte-raw-row"
}
const _hoisted_19 = { colspan: "10" }
const _hoisted_20 = { class: "cte-raw-panel" }
const _hoisted_21 = {
  key: 0,
  class: "cte-native"
}
const _hoisted_22 = { class: "cte-native-table" }
const _hoisted_23 = {
  key: 1,
  class: "cte-native"
}
const _hoisted_24 = { class: "cte-native-table" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 2,
  class: "cte-native"
}
const _hoisted_28 = { class: "cte-native-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Object.hasOwn(_ctx.row, 'parsed'))
      ? (_openBlock(), _createElementBlock("tr", {
          key: 0,
          class: _normalizeClass(["cte-row cte-raw-toggle", _ctx.rowStatusClass]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpanded && _ctx.toggleExpanded(...args)))
        }, [
          _createElementVNode("td", _hoisted_1, [
            (!_ctx.row.isNotFound && _ctx.hasRaw)
              ? (_openBlock(), _createElementBlock("button", _hoisted_2, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["cte-caret", { 'cte-caret-open': _ctx.expanded }])
                  }, "▸", 2)
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("span", null, [
              _createTextVNode(_toDisplayString(_ctx.shortTimestamp), 1)
            ])), [
              [_directive_tippy, { content: _ctx.fullTimestamp, placement: 'top' }]
            ]),
            (_ctx.hasTerminalDifferentFromDischarge)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.terminalType), 1)
                  ])), [
                    [_directive_tippy, { content: 'Scraped at ' + _ctx.terminalType, placement: 'top' }]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_5, "Not Found"))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                (_ctx.row.isPickedUp)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "n/a"))
                  : (_ctx.row.isAvailable)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Yes"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "No"))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [
                  (_ctx.row.isPickedUp)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('container_location')]])
                      }, "Off-dock", 2))
                    : (_ctx.row.isAvailable || _ctx.row.isInYard)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('container_location')]])
                        }, "In Yard", 2))
                      : (!_ctx.row.isOffVessel)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: _normalizeClass(["uk-label", [_ctx.hasFieldChangedClass('container_location')]])
                          }, "On Vessel", 2))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: _normalizeClass(["uk-label", [_ctx.hasFieldChangedClass('container_location')]])
                          }, _toDisplayString(_ctx.parsed['container_location']), 3))
                ])), [
                  [_directive_tippy, _ctx.parsed['container_location']]
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                (_ctx.parsed['holds']?.['customs'])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label", [ _ctx.hasFieldChangedClass('holds', 'customs'), (_ctx.parsed['holds']['customs']['active'] ? 'uk-label-danger' : 'uk-label-success') ]])
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.parsed['holds']['customs']['status'].toUpperCase()), 1)
                      ])), [
                        [_directive_tippy, _ctx.getParsedHoldDetailsWithEmptyPlaceholder('customs')]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('holds', 'customs')]])
                    }, "-", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                (_ctx.parsed['holds']?.['line'])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label", [ _ctx.hasFieldChangedClass('holds', 'line'), (_ctx.parsed['holds']['line']['active'] ? 'uk-label-danger' : 'uk-label-success') ]])
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.parsed['holds']['line']['status'].toUpperCase()), 1)
                      ])), [
                        [_directive_tippy, _ctx.getParsedHoldDetailsWithEmptyPlaceholder('line')]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('holds', 'line')]])
                    }, "-", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                (_ctx.parsed['holds']?.['terminal'])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label", [ _ctx.hasFieldChangedClass('holds', 'terminal'), (_ctx.parsed['holds']['terminal']['active'] ? 'uk-label-danger' : 'uk-label-success') ]])
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.parsed['holds']['terminal']['status'].toUpperCase()), 1)
                      ])), [
                        [_directive_tippy, _ctx.getParsedHoldDetailsWithEmptyPlaceholder('terminal')]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('holds', 'terminal')]])
                    }, "-", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                (_ctx.parsed['holds']?.['usda'])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label", [ _ctx.hasFieldChangedClass('holds', 'usda'), (_ctx.parsed['holds']['usda']['active'] ? 'uk-label-danger' : 'uk-label-success') ]])
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.parsed['holds']['usda']['status'].toUpperCase()), 1)
                      ])), [
                        [_directive_tippy, _ctx.getParsedHoldDetailsWithEmptyPlaceholder('usda')]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('holds', 'usda')]])
                    }, "-", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                (_ctx.parsed['holds']?.['other'])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label", [ _ctx.hasFieldChangedClass('holds', 'other'), (_ctx.parsed['holds']['other']['active'] ? 'uk-label-danger' : 'uk-label-success') ]])
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.parsed['holds']['other']['status'].toUpperCase()), 1)
                      ])), [
                        [_directive_tippy, _ctx.getParsedHoldDetailsWithEmptyPlaceholder('other')]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('holds', 'other')]])
                    }, "-", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                (_ctx.parsed['demurrage_amount'] && parseFloat(_ctx.parsed['demurrage_amount']) > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["uk-label uk-label-warning", [_ctx.hasFieldChangedClass('demurrage_amount')]])
                    }, " $" + _toDisplayString(_ctx.parsed['demurrage_amount']), 3))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["uk-label uk-label-success", [_ctx.hasFieldChangedClass('demurrage_amount')]])
                    }, "—", 2))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.row.isNotFound)
            ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                _createElementVNode("span", {
                  class: _normalizeClass(["", [_ctx.hasFieldChangedClass('last_free_day')]])
                }, _toDisplayString(_ctx.lastFreeDay), 3)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.isNotFound && _ctx.expanded && _ctx.hasRaw)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
          _createElementVNode("td", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "cte-raw-title" }, "Original terminal data", -1)),
              (_ctx.terminalType === 'TRAPAC')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("table", _hoisted_22, [
                      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th"),
                          _createElementVNode("th"),
                          _createElementVNode("th"),
                          _createElementVNode("th", { colspan: "4" }, "Holds"),
                          _createElementVNode("th"),
                          _createElementVNode("th", { colspan: "3" }, "Dimensions"),
                          _createElementVNode("th"),
                          _createElementVNode("th")
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Number"),
                          _createElementVNode("th", null, "Terminal ID"),
                          _createElementVNode("th", null, "Shipline ID"),
                          _createElementVNode("th", null, "Ship Line"),
                          _createElementVNode("th", null, "Customs"),
                          _createElementVNode("th", null, "USDA"),
                          _createElementVNode("th", null, "Terminal Hold (and Details)"),
                          _createElementVNode("th", null, "Yard Status"),
                          _createElementVNode("th", null, "Size"),
                          _createElementVNode("th", null, "Type"),
                          _createElementVNode("th", null, "Height"),
                          _createElementVNode("th", null, "Vessel / Voyage"),
                          _createElementVNode("th", null, "LFD")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.containerNumber), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.terminal_id || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.line_id || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.holdsLine || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.holdsCustoms || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.holdsUSDA || ''), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.raw.terminalHold || []), (holdString, holdIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                style: _normalizeStyle({ borderBottom: Number(holdIdx) < (_ctx.raw.terminalHold || []).length - 1 ? '1px solid #ccc' : 'none' }),
                                key: holdString+'-'+holdIdx
                              }, _toDisplayString(holdString), 5))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.yardStatus || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.size || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.cargoType || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.height || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.vessel || '') + "/" + _toDisplayString(_ctx.raw.voyage || ''), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.raw.lfd || ''), 1)
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.terminalType === 'OICT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("table", _hoisted_24, [
                        _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Container"),
                            _createElementVNode("th", null, "Available for pick-up?"),
                            _createElementVNode("th", null, "Size/Type"),
                            _createElementVNode("th", null, "Holds/Fees"),
                            _createElementVNode("th", null, "Additional Information")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.containerNumber), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.raw.container_available || ''), 1),
                              _createElementVNode("small", null, _toDisplayString(_ctx.raw.container_available_extra_info || ''), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.raw.size_type || ''), 1),
                              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("small", null, _toDisplayString(_ctx.raw.size_type_long || ''), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, [
                                _cache[4] || (_cache[4] = _createTextVNode("Customs Release Status: ", -1)),
                                _createElementVNode("strong", null, [
                                  _createTextVNode(_toDisplayString(_ctx.raw.customs_release || '') + " ", 1),
                                  (_ctx.raw.customs_release_datetime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode("(date: " + _toDisplayString(_ctx.raw.customs_release_datetime || '') + ")", 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[6] || (_cache[6] = _createTextVNode("Line Release Status: ", -1)),
                                _createElementVNode("strong", null, [
                                  _createTextVNode(_toDisplayString(_ctx.raw.line_release || '') + " ", 1),
                                  (_ctx.raw.line_release_datetime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                        _createTextVNode("(date: " + _toDisplayString(_ctx.raw.line_release_datetime || '') + ")", 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[7] || (_cache[7] = _createTextVNode("Holds: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.holds || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[8] || (_cache[8] = _createTextVNode("Add'l Holds Info: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.additional_holds_info || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[9] || (_cache[9] = _createTextVNode("Total Fees: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.total_fees || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[10] || (_cache[10] = _createTextVNode("Satisfied Thru: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.last_free_day || ''), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, [
                                _cache[11] || (_cache[11] = _createTextVNode("Location: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.yard_location || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[12] || (_cache[12] = _createTextVNode("Ves/Voy: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.vessel || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[13] || (_cache[13] = _createTextVNode("Line: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.line_id || ''), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[14] || (_cache[14] = _createTextVNode("Req. Acc.: ", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.raw.required_accessory || ''), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.terminalType === 'ETS')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("table", _hoisted_28, [
                          _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, "Container:"),
                              _createElementVNode("td", null, "Available"),
                              _createElementVNode("td", null, "Size"),
                              _createElementVNode("td", null, "Height"),
                              _createElementVNode("td", null, "Type"),
                              _createElementVNode("td", null, "Customs Status"),
                              _createElementVNode("td", null, "Carrier Status"),
                              _createElementVNode("td", null, "Terminal Hold"),
                              _createElementVNode("td", { colspan: "3" }, "Demurrage "),
                              _createElementVNode("td", null, "Appointment"),
                              _createElementVNode("td", null, "Yard Location"),
                              _createElementVNode("td", null, "Wheeled/Decked")
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td", null, "Status"),
                              _createElementVNode("td", null, "Amount"),
                              _createElementVNode("td", null, "Good Through (LFD)"),
                              _createElementVNode("td"),
                              _createElementVNode("td"),
                              _createElementVNode("td")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, _toDisplayString(_ctx.containerNumber), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.available || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.container_size || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.container_height || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.container_type || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.customs_hold || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.line_hold || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.terminal_hold || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.demurrage_status || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.demurrage_amount || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.last_free_day || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.appointment_datetime || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.container_location || ''), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.raw.wheeled_decked || ''), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}